import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const useAssignmentStatus = (userId) => {
  const [isAssigned, setIsAssigned] = useState(null);
  const [assignmentRequest, setAssignmentRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;

    const checkAssignment = async () => {
      try {
        // Check if user is in any group
        const { data: groupMembership, error: groupError } = await supabase
          .from('group_members')
          .select('id')
          .eq('user_id', userId)
          .limit(1)
          .maybeSingle();

        if (groupError && groupError.code !== 'PGRST116') {
          console.error('Error checking group membership:', groupError);
        }

        setIsAssigned(!!groupMembership);

        // If not assigned, check for pending/rejected request
        if (!groupMembership) {
          const { data: request, error: requestError } = await supabase
            .from('assignment_requests')
            .select('*, requested_subgroup:requested_subgroup_id(id, name, parent_id)')
            .eq('user_id', userId)
            .in('status', ['pending', 'rejected'])
            .order('requested_at', { ascending: false })
            .limit(1)
            .maybeSingle();

          if (requestError && requestError.code !== 'PGRST116') {
            console.error('Error fetching request:', requestError);
          }

          setAssignmentRequest(request || null);
        }
      } catch (error) {
        console.error('Error in checkAssignment:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAssignment();
  }, [userId]);

  return { isAssigned, assignmentRequest, loading };
};